export default {
    buttons: {
        change_role: 'Изменить роль',
        delete_company_user: 'Удалить пользователя компании',
        save: 'Сохранить',
        add_user: 'Добавить пользователя',
        show_user: 'Показать на публичных страницах',
        show_public_profile: 'Разрешить предварительный просмотр профиля',
    },
    fields: {
        company_role: {
            label: 'Роль в компании',
            placeholder: 'Выберите роль в компании',
        },
    },
}
